import { pushAAPurchaseEvent } from '../utils/aaAnalytics';

// TODO: we should migrate to TypeScript
//
// type DataLayerEvent = {
//   event: string;
//   virtualUrl: string;
//   pageTitle: string;
// };
//
// type PartnerConfig = {
//   displayName: string;
//   campaign: string;
//   isCustomer: boolean;
//   hostname?: string;
//   path?: string;
//   color?: string;
//   status?: string;
//   dataLayerEvent?: DataLayerEvent;
//   useGtag?: boolean;
//   purchaseEvent?: (json: any) => void;
//   showCarInsurance?: boolean;
// };

export const PARTNER_CONFIG = {
  AA: {
    hostname: 'aa',
    path: '/aa/',
    displayName: 'AA',
    campaign: 'aa',
    isCustomer: true,
    color: '#0d59bf',
    status: 'current',
    dataLayerEvent: {
      event: 'virtualPageview',
      virtualUrl: '/aa/paymentsuccess',
      pageTitle: 'Payment Success',
    },
    useGtag: true,
    purchaseEvent: pushAAPurchaseEvent,
  },
  AA_MEMBER: {
    displayName: 'AA',
    campaign: 'aa',
    isCustomer: true,
    color: '#0d59bf',
    status: 'current',
    dataLayerEvent: {
      event: 'virtualPageview',
      virtualUrl: '/aa/paymentsuccess',
      pageTitle: 'Payment Success',
    },
    useGtag: true,
    purchaseEvent: pushAAPurchaseEvent,
  },
  GASPY: {
    hostname: 'gaspy',
    path: '/gaspy/',
    displayName: 'Gaspy',
    campaign: 'gaspy',
    isCustomer: true,
  },
  VTNZ: {
    hostname: 'vtnz',
    path: '/vtnz/',
    displayName: 'VTNZ',
    campaign: 'vtnz',
    isCustomer: true,
    color: '#E87722',
  },
  MONEYHUB: {
    hostname: 'moneyhub',
    path: '/moneyhub/',
    displayName: 'Autosure',
    campaign: 'mhub',
    isCustomer: false,
  },
  MYAUTOSHOP: {
    hostname: 'myautoshop',
    path: '/myautoshop/',
    displayName: 'Autosure',
    campaign: 'mas',
    isCustomer: false,
  },
  TFAF_AUTOSURE: {
    hostname: 'online',
    path: '/autosure/',
    displayName: 'Autosure',
    campaign: 'autosure',
    isCustomer: false,
    showCarInsurance: true,
  },
  TFAF: {
    path: '/turners/',
    displayName: 'Autosure',
    campaign: 'autosure',
    isCustomer: false,
  },
  QUASHED: {
    hostname: 'quashed',
    path: '/quashed/',
    displayName: 'Autosure',
    campaign: 'quashed',
    isCustomer: false,
  }
};
